const initialState = {
  data: [],
  isSuccess: false,
  message: null,
  loading: false,
  paginationLoading: false,
  error: null,
  pagination: null,
};

const ChatWidgetReducer = (state = initialState, action) => {
  switch (action.type) {
    // Initial load (page 1) — replaces messages
    case "fetch_user_chat":
      return {
        ...state,
        data: action.payload?.Data || [],
        pagination: {
          PageNumber: action.payload?.PageNumber,
          PageSize: action.payload?.PageSize,
          TotalPages: action.payload?.TotalPages,
          TotalRecords: action.payload?.TotalRecords,
          NextPage: action.payload?.NextPage,
          PreviousPage: action.payload?.PreviousPage,
        },
        isSuccess: action.payload?.IsSuccess,
        message: action.payload?.Message,
        loading: false,
        paginationLoading: false,
      };

    // Subsequent pages — PREPEND older messages so newest stays at bottom
    case "fetch_user_chat_append":
      return {
        ...state,
        data: [...(action.payload?.Data || []), ...state.data],
        pagination: {
          PageNumber: action.payload?.PageNumber,
          PageSize: action.payload?.PageSize,
          TotalPages: action.payload?.TotalPages,
          TotalRecords: action.payload?.TotalRecords,
          NextPage: action.payload?.NextPage,
          PreviousPage: action.payload?.PreviousPage,
        },
        isSuccess: action.payload?.IsSuccess,
        message: action.payload?.Message,
        paginationLoading: false,
      };

    case "add_chat_message":
      return {
        ...state,
        data: [...state.data, action.payload],
      };

    case "clear_chat":
      return {
        ...state,
        data: [],
        pagination: null,
        loading: false,
        paginationLoading: false,
        error: null,
      };

    default:
      return state;
  }
};

export default ChatWidgetReducer;
